export enum PaymentContext {
  Consultation = 'consultation',
  OnboardChannelingPartner = 'onboard-channeling-partner',
  CustomPayment = 'custom-payment',
  PreapproveChannelingPartner = 'preapprove-channeling-partner',
}
